import { Lock, ContactMail } from '@mui/icons-material'
import { Box, Button, Grid, TextField } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'
import './login.css'
import { useForm } from "react-hook-form";
import Spinner from '../Layout/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useEffect , useState} from 'react';
import { login, reset } from '../../features/auth/authSlice';
import authService from '../../features/auth/authService';

const EMAIL_NAME_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


function Login(props) {

    useEffect(() => {
        document.title = props.title
      }, []);

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { role, isLoading, isError, isSuccess, message } = useSelector(
        (state) => state.auth
    )
    const [email, setEmail] = useState('');

    const { register, handleSubmit, formState: { errors, isValid: isLoginFormValid } } = useForm({
        mode: 'all',
        reValidateMode: 'all',
    });

    useEffect(() => {
        if (isError) {
            toast.error(message);
        }
        if (isSuccess) {
            localStorage.setItem("selectedYear", '');
            localStorage.setItem("academicyear",'currentyear');
           // toast.success('',message);
            if (role === 'admin') {
                navigate('/coordinator');
            } else if (role === 'dc' || role === 'user') {
                navigate('/home');
            }
        }

        dispatch(reset())

    }, [isError, isSuccess, message, navigate, dispatch]);

    //   useEffect(() => {
    //     dispatch(reset())
    //   },[navigate])

    const onSubmit = (userData) => {
        console.log(userData);
        userData.email = email;
        console.log(email);
        if (!email || !userData.password) {
            toast.warn("Enter a valid email address and password for the CalSCHLS Coordinator Portal.")
        } else if(!EMAIL_NAME_REGEX.test(email)){
            toast.warn("Enter a valid email address and password for the CalSCHLS Coordinator Portal.")
        } else {
            dispatch(login(userData))
        }
        // if (isLoginFormValid) {
        //     dispatch(login(userData))
        // } else {
        //     toast.info("Enter a valid email address and password for the CalSCHLS Coordinator Portal.")
        // }
    }

    const forgotPwd = () =>{
        console.log(email);
        if(email){
            var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
            if (reg.test(email) == false) {
              toast.warning('Invalid EmailId, provide proper Email address.');
            }else{
                authService.checkUserExists(email.trim())
                .then((isExist) =>{
                    console.log(isExist);
                    if(isExist.success){
                    toast.success(isExist.message)
                    }else{
                    toast.warning(isExist.message)
                    }
                })
                .catch((err) =>{
                    console.log(err);
                    toast.error(err.message)

                });
        }
    }else{
        toast.error("Provide your email and then click “Forgot password?”");
    }
       // navigate('/forgotpassword')
    }

    return (
        <>
            {isLoading && <Spinner />}
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={0} style={{ marginTop: '20px' }}>
                        <Grid item xs={1.74}></Grid>
                        <Grid item xs={5.4}>
                            <div className="contentLeft" style={{ marginTop: "10px" }}>
                                <img src={require('../../assets/images/menuHeader.png')} alt="calSchls" className="logo-img" />
                                <div className="logo-sub-title">
                                    <span className="cordinator-portal">CalSCHLS Coordinator Portal</span>
                                </div>
                            </div>
                        </Grid>

                        <Grid item xs={4}>
                            <div className="contentRight">
                                <img src={require('../../assets/images/wested.png')} alt="wested" className='westEdLogo'/>
                            </div>
                        </Grid>
                        <Grid item xs={1}></Grid>
                    </Grid>


                    <Grid container spacing={0} style={{ marginTop: '85px' }}>
                        <Grid item xs={12}>
                            <div className='loginTable'>
                                <div className="loginRow">
                                    <div className="loginCell" style={{ paddingTop: '10px', color: '#fff', fontSize: '28px', fontWeight: 300 }}>
                                        <span>Welcome</span>
                                    </div>
                                </div>

                                <div style={{ marginTop: '25px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                        <ContactMail sx={{ color: '#fff', mr: 1.5, my: 0.5 }} />
                                        <TextField id="email" name="email" label="Email" variant="standard"
                                            sx={{
                                                width: '90%', input: {
                                                    color: "#fff",
                                                }, "& label": {
                                                    "&.Mui-focused": {
                                                        color: '#fff'
                                                    }
                                                },
                                            }}
                                            InputLabelProps={{ style: { color: '#fff' } }}
                                            autoComplete="on"
                                            {...register('email')}
                                            defaultValue={email} // Set the initial value to the autofilled email
                                            value={email} // Add this line to bind the email state variable to the text field value
                                            onChange={(e) =>{ setEmail(e.target.value)}} // Add this line to update the email state variable                                          


                                        />
                                    </Box>

                                    <Box>

                                        {/* use role="alert" to announce the error message */}
                                        {/* {errors.email && errors.email.type === "required" && (
                                        <span className="errorClass">Please provide an <b>Email</b></span>
                                    )}
                                    {errors.email && (errors.email.type === "pattern") && (
                                        <span className="errorClass">
                                            Email must be a valid email address
                                        </span>
                                    )} */}
                                    </Box>

                                    <Box sx={{ display: 'flex', alignItems: 'flex-end', marginTop: '50px' }}>
                                        <Lock sx={{ color: '#fff', mr: 1.5, my: 0.5 }} />
                                        <TextField type="password" id="password" name="password" label="Password" variant="standard" sx={{
                                            width: '90%', input: {
                                                color: "#fff",
                                            }, "& label": {
                                                "&.Mui-focused": {
                                                    color: '#fff'
                                                }
                                            },
                                        }}
                                        autoComplete="on"
                                            InputLabelProps={{ style: { color: '#fff' } }}
                                            {...register('password')}
                                        />
                                    </Box>
                                    <Box>
                                        {/* use role="alert" to announce the error message */}
                                        {/* {errors.password && errors.password.type === "required" && (
                                        <span className="errorClass">Please provide an <b>Password</b></span>
                                    )} */}
                                    </Box>
                                </div>
                                <div style={{ marginTop: '55px', textAlign: 'center' }}>
                                    <Button type="submit" className='signup' sx={{
                                        textAlign: 'center', height: 36, backgroundColor: '#fff',
                                        width: 415, borderRadius: 25, color: '#003c68', ':hover': {
                                            bgcolor: '#fff', // theme.palette.primary.main
                                            color: '#003c68',
                                        },
                                    }}>Sign in</Button>
                                </div>

                                <div style={{ marginTop: '30px', marginBottom: '30px' }}>
                                    <Link to={"/register"} style={{ background: '#003c68', float: 'left', color: '#fff', cursor: 'pointer', textDecoration: 'none', fontSize: "14px", fontWeight: "500", marginLeft: '15px' }}>
                                        Create an account
                                    </Link>

                                    <div onClick = {forgotPwd} style={{ backgroundColor: '#003c68', color: '#fff', float: 'right', cursor: 'pointer', fontSize: "14px", fontWeight: "500", marginRight: '25px' }}>
                                        Forgot password?
                                    </div>
                                    <div className='clear'></div>
                                </div>

                            </div>
                        </Grid>
                    </Grid>

                </Box >
            </form>
        </>
    )
}

export default Login